export default {
  SET_ESTOQUE(state, payload) {
    state.itensEstoque = payload;
  },
  SET_DESEMBARACO(state, payload) {
    state.itensDesembaraco = payload;
  },
  SET_FUTURO(state, payload) {
    state.itensFuturo = payload;
  },
  SET_COLUNAS_DINAMICAS(state, payload) {
    state.colunasDinamicasEstoque = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_EMPRESAS_ARMAZENAGEM(state, payload) {
    state.empresasArmazenagem = payload;
  },
};
